export enum State {
  Unchanged = 'Unchanged',
  Insert = 'Insert',
  Changed = 'Changed',
  Deleted = 'Deleted',
}
